import React from 'react';
import ReactDOM from 'react-dom';
import Loadable from 'react-loadable';

export const LoginDialog = Loadable({
    loader: () => import(/* webpackChunkName: "LoginDialog" */ './loginDialog'),
    loading: () => <div />,
});
